import { render } from "./line-scale.vue?vue&type=template&id=01380f0e"
import script from "./line-scale.vue?vue&type=script&lang=js"
export * from "./line-scale.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "01380f0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01380f0e', script)) {
    api.reload('01380f0e', script)
  }
  
  module.hot.accept("./line-scale.vue?vue&type=template&id=01380f0e", () => {
    api.rerender('01380f0e', render)
  })

}

script.__file = "src/loaders/line-scale.vue"

export default script